import { infoApi as base } from '../base';
import { infoApi as AT } from './AT';
import { infoApi as RO } from './RO';
import { infoApi as CZ } from './CZ';

export const featureConfigMap = {
    base,
    AT,
    RO,
    CZ,
};
